import { IconProps } from "../../../types/style";

const ActivitiesWallet = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M19.8 8.41949V13.5695C19.8 16.6495 18.04 17.9695 15.4 17.9695H6.60995C6.15995 17.9695 5.72996 17.9295 5.32996 17.8395C5.07996 17.7995 4.83996 17.7295 4.61996 17.6495C3.11996 17.0895 2.20996 15.7895 2.20996 13.5695V8.41949C2.20996 5.33949 3.96995 4.01953 6.60995 4.01953H15.4C17.64 4.01953 19.25 4.96953 19.68 7.13953C19.75 7.53953 19.8 7.94949 19.8 8.41949Z"
          fill={color}
        />
        <path
          d="M22.8001 11.4196V16.5696C22.8001 19.6496 21.0401 20.9696 18.4001 20.9696H9.61008C8.87008 20.9696 8.20009 20.8697 7.62009 20.6497C6.43009 20.2097 5.62008 19.2997 5.33008 17.8397C5.73008 17.9297 6.16008 17.9696 6.61008 17.9696H15.4001C18.0401 17.9696 19.8001 16.6496 19.8001 13.5696V8.41962C19.8001 7.94962 19.7601 7.52965 19.6801 7.13965C21.5801 7.53965 22.8001 8.87962 22.8001 11.4196Z"
          fill={color}
        />
        <path
          d="M10.9999 13.6404C12.4579 13.6404 13.6399 12.4584 13.6399 11.0004C13.6399 9.54233 12.4579 8.36035 10.9999 8.36035C9.54185 8.36035 8.35986 9.54233 8.35986 11.0004C8.35986 12.4584 9.54185 13.6404 10.9999 13.6404Z"
          fill={color}
        />
        <path
          d="M5.28003 8.75C4.87003 8.75 4.53003 9.09 4.53003 9.5V12.5C4.53003 12.91 4.87003 13.25 5.28003 13.25C5.69003 13.25 6.03003 12.91 6.03003 12.5V9.5C6.03003 9.09 5.70003 8.75 5.28003 8.75Z"
          fill={color}
        />
        <path
          d="M16.71 8.75C16.3 8.75 15.96 9.09 15.96 9.5V12.5C15.96 12.91 16.3 13.25 16.71 13.25C17.12 13.25 17.46 12.91 17.46 12.5V9.5C17.46 9.09 17.13 8.75 16.71 8.75Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ActivitiesWallet;
